import { isEmpty, isObject, isArray, includes } from 'lodash'
import uniqid from 'uniqid'

export default {
  methods: {
    _show (condition, data = this.cData, rowData) {
      return this._evaluateCondition(condition, data, rowData)
    },
    _evaluateItems (items) {
      if (!isArray(items)) return null
      return items.filter(item => {
        if (!item.condition) return true
        // return item.condition
        return this._show(item.condition)
      })
    },
    _evaluateCondition (condition, data, rowData) {
      function inspectRule (rule) {
        if (Object.prototype.hasOwnProperty.call(rule, 'all') || Object.prototype.hasOwnProperty.call(rule, 'any')) {
          return evaluateCondition(rule)
        }
        let rowPrefix = 'row:'
        let value = rule.compare ? data[rule.compareKey] : rule.value
        let isRowRule = rule.key ? rule.key.indexOf(rowPrefix) > -1 : false
        let dataValue = isRowRule
        ? rowData
        ? rowData[rule.key.split(rowPrefix)[1]]
        : null
        : data[rule.key]
        
        if (isRowRule && !rowData) return false
        
        switch (rule.operator) {
          case 'equals': return dataValue === value
          case 'notEquals': return dataValue !== value
          case 'greaterThan': return dataValue > value
          case 'lessThan': return dataValue < value
          case 'hasValue': return dataValue !== undefined && dataValue !== null
          case 'in': return includes(value, dataValue)
          case 'notIn': return !includes(value, dataValue)
          default: 
        }
      }
      // function evaluateConditions (rules) {
        //   if (!isArray(rules)) {
          //     console.error('evaluateConditions: rules were not supplied as array')
          //     return []
          //   }
          
          //   var booleanArray = rules.map((rule) => {
            //     return inspectRule(rule)
            //   })
            //   return booleanArray
            // }
      function evaluateCondition (condition) {
        let operator = Object.prototype.hasOwnProperty.call(condition, 'all')  ? 'all' : 'any'
        let rules = condition[operator]
        if (!rules) return true
        return operator === 'all'
        ? rules.map(inspectRule).every(Boolean)
        : rules.map(inspectRule).some(Boolean)
      }
            
      if (condition === true) return true
      if (!isObject(condition)) return true

      // var conditionOperator = Object.keys(condition)[0]

      // switch (conditionOperator) {
      //   case 'any': return evaluateConditions(condition[conditionOperator]).some(Boolean)
      //   case 'all': return evaluateConditions(condition[conditionOperator]).every(Boolean)
      //   case 'undefined': return true
      //   default: return true
      // }
      return evaluateCondition(condition)
    },
    _conditionType (condition) {
      if (isEmpty(condition)) return
      return Object.keys(condition)[0]
    },
    _conditionRules (condition) {
      return (condition[this._conditionType(condition)] || {}) || []
    },
    _idify (condition) {
      function idify (condition) {
        if (!condition.all && !condition.any) return condition
        let type = condition.all ? 'all' : 'any'
        return {
          type,
          id: uniqid(),
          rules: condition[type].map(idify)
        }
      }
      if (condition.id) {
        return condition
      } else {
        return idify({...condition})
      }
    },
    _unidify (condition) {
      function unidify (condition) {
        /*eslint no-unused-vars: ["error", { "ignoreRestSiblings": true }]*/
        let { id, ...restCondition } = condition
        if (!condition.rules) return restCondition
        let { type, rules } = condition
        return { 
          [type] : rules.map(unidify)
        }
      }
      return unidify(condition)
    }
  }
}
